import type { z } from 'zod';

import { LegacyExamQuestionMarkOutcome } from './enums';
import type { LegacyExamQuestionAttemptSchema } from './schemas';

type LegacyExamQuestionAttemptField = keyof z.infer<typeof LegacyExamQuestionAttemptSchema>;

const listAttributes = [
  'id',
  'studentId',
  'subject',
  'examCode',
  'attemptNumber',
  'questionId',
  'examId',
  'attemptId',
  'marksBreakdown',
  'markerId',
  'markerDetails',
  'markedDatetime',
  'creationDatetime',
  'outcome',
  'mark',
  'maxMark',
  'examLabel',
  'examType',
  'questionLabelParts',
  'inaccuracyMarks',
  'sillyMarks',
  'criteria',
  'markerComment',
  'markingMode',
] as const satisfies readonly LegacyExamQuestionAttemptField[];

const getAttributes = [
  ...listAttributes,
] as const satisfies readonly LegacyExamQuestionAttemptField[];

const updateAttributes = [
  'questionLabelParts',
  'mark',
  'maxMark',
  'outcome',
  'examLabel',
  'markedDatetime',
  'markerId',
  'markerDetails',
  'type',
  'mcqOpts',
  'missedMarks',
  'sillyMarks',
  'inaccuracyMarks',
  'marksBreakdown',
  'examType',
  'subject',
  'examCode',
  'studentDetails',
  'status',
  'criteria',
  'markerComment',
  'markingMode',
] as const satisfies readonly LegacyExamQuestionAttemptField[];

export const LegacyExamQuestionAttemptAttributes = {
  List: listAttributes,
  Get: getAttributes,
  Update: updateAttributes,
};

// Maximum number of papers that can be in progress of marking at a time per marker
export const MAX_SIMULTANEOUS_LEGACY_MARKING = 30;

export const ERROR_TYPES = [
  {
    key: LegacyExamQuestionMarkOutcome.Missed,
    value: LegacyExamQuestionMarkOutcome.Missed,
    label: 'Missed',
  },
  {
    key: LegacyExamQuestionMarkOutcome.SillyMistake,
    value: LegacyExamQuestionMarkOutcome.SillyMistake,
    label: 'Silly Mistake',
  },
  {
    key: LegacyExamQuestionMarkOutcome.Inaccuracy,
    value: LegacyExamQuestionMarkOutcome.Inaccuracy,
    label: 'Incorrect',
  },
];
